module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form-input', {
    staticClass: "facebook-connector",
    class: _vm.$style.root
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "slot": "label",
      "for": String(_vm._uid)
    },
    slot: "label"
  }, [_vm._v(_vm._s(_vm.$t('draft_field.title.facebook-page')))]), _c('template', {
    attrs: {
      "slot": "input"
    },
    slot: "input"
  }, [_c('b-input-group', [_c('div', {
    staticClass: "input-group-addon",
    attrs: {
      "slot": "left"
    },
    slot: "left"
  }, [(!_vm.selected) ? _c('icon', {
    attrs: {
      "name": "search",
      "scale": "1"
    }
  }) : _c('img', {
    attrs: {
      "src": _vm.selected.picture,
      "width": "20",
      "heigth": "20"
    }
  })], 1), _c('div', {
    staticClass: "input-container"
  }, [_c('v-autocomplete', {
    directives: [{
      name: "autocomplete-extend",
      rawName: "v-autocomplete-extend"
    }],
    ref: "autocomplete",
    attrs: {
      "name": "facebook_page",
      "placeholder": _vm.$t("draft_field.placeholder.facebook-page"),
      "id": String(_vm._uid),
      "min-len": 2,
      "wait": 300,
      "items": _vm.items,
      "component-item": _vm.itemTemplate,
      "auto-select-one-item": false,
      "get-label": _vm.getLabel,
      "input-class": "form-control"
    },
    on: {
      "update-items": _vm.onUpdateItems,
      "change": _vm.onChange
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }), _c('label', {
    staticClass: "control-label",
    on: {
      "click": _vm.clearSearch
    }
  }, [(_vm.selected) ? _c('icon', {
    attrs: {
      "name": "close"
    }
  }) : _vm._e()], 1)], 1), _c('b-input-group-button', {
    attrs: {
      "slot": "right"
    },
    slot: "right"
  }, [_c('b-btn', {
    staticClass: "btn-connect",
    attrs: {
      "name": "fb_page_connect",
      "disabled": !_vm.buttonEnabled,
      "variant": _vm.buttonEnabled ? "target" : "inactive",
      "data-connect-status": _vm.connectStatus
    },
    on: {
      "click": _vm.onConnect
    }
  }, [_vm._v(_vm._s(_vm.$t(_vm.buttonText)))])], 1)], 1), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.claimLink),
      expression: "claimLink"
    }],
    staticClass: "claimlink"
  }, [_c('a', {
    attrs: {
      "href": _vm.claimLink,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v(_vm._s(_vm.$t('pos.settings.facebook-page.instruction')))])])], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5117560c"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/facebook-connector/FacebookConnector.vue
// module id = 931
// module chunks = 1